import { SmartTable } from '../../../../components/smart-table/smart-table.model';

export class Controller {

    /** @ngInject */
    constructor(
        $state,$filter) {
	this.$state = $state;
	 this.$filter = $filter;
		this.st= new SmartTable();
		this.st.displayedItems=this.sharedAccounts;		
	}
	
	$onInit() {
		const companyName = this.currentCompany.companyName;
		
		this.export = {
            template: 'sharedloginitem',
            get name() {
                return `${companyName}_SAASPASS_SharedLoginItem`;
            },
            fields: [
                'saaspassId',
                'displayName',
                'serviceName',
                'customServiceName',
                'enabled2fa',
                'username',
                'corporateServiceAccountId',
            ],
        };
	}
	
	showAccountData(key) {
		if (key==0) return true;
		return this.st.displayedItems[key-1].corporateServiceAccountId!=this.st.displayedItems[key].corporateServiceAccountId
		
	}
	showAccountDataClass(key) {
		
		if(key>0 && ( this.st.displayedItems[key-1].corporateServiceAccountId!=this.st.displayedItems[key].corporateServiceAccountId)) {
			return 'sp_topBorderStyle';
		} else {
			return 'sp_noTopBorder';
		}
		
	}

}


// WEBPACK FOOTER //
// ./src/portal/states/company/reports/sharing-center-reports/sharing-center-reports.controller.js